// extracted by mini-css-extract-plugin
export default {"container":"FormCheckbox_container__hIrH0","label":"FormCheckbox_label__wGcW8","checkbox":"FormCheckbox_checkbox__7ih3A"};